import {ApiClientFactory, ApiClientFactoryInterface} from "./clients";
import {Headers} from "../types";
import {CompanyManager} from "../CompanyManager";

export class CompanyManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers = {}) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/company`,
      headers
    );
  }

  createCompanyManager(token: string): CompanyManager {
    return new CompanyManager(this.apiClientFactory.createAuthorizedClient(token));
  }
    
}